import { DocumentAiExtractionStatus, DocumentalEvaluationResult } from "../interfaces/document-category.interface";
import { Downpayment } from "./downpayment";
import { v4 as uuidv4 } from "uuid";

export type DocumentStatus =
  | "error"
  | "warning"
  | "pending"
  | "rejected"
  | "sent"
  | "approved"
  | "encrypted"
  | "invalid"
  | "loading"
  | "classifying"
  | "uploading"
  | "class"
  | "no_text"
  | "duplicate";

export class Document {
  id: string | number;
  name: string;
  status: DocumentStatus;
  category: string;
  original_filename: string;
  created_at: string;
  new_doc = false;
  content?: string | ArrayBuffer;
  type?: string;
  password?: string;
  show?: boolean;
  drive_attributes?: object;
  downpayments?: Downpayment[];
  resource_id?: string;
  resource_class?: string;
  ai_validation_pending: boolean;
  classifiying?: boolean;
  ai_warnings: {
    id: number;
    type: string;
    severity?: string;
    title: string;
    message: string;
    alt_message?: string;
  }[];
  documental_evaluation: DocumentalEvaluationResult | null;
  metadata: Partial<DocumentMetadata> & GenericRecord;
  disable_erase?: boolean;
  unique_key: string;
  period: string;
  ai_extraction_status: DocumentAiExtractionStatus;
  constructor(values: Record<PropertyKey, any> = {}) {
    Object.assign(this, values);
    this.name = this.name || values["original_filename"];
    // Generate a secure random unique string using uuid
    this.unique_key = this.unique_key || uuidv4();
  }

  account_number: string | null;
  clabe: string | null;

  // For loading state when fetching document
  is_loading_document = false;
}

// Alias for the Document object
export type DocumentFile = Document;

type GenericRecord = Record<string, any>;

type DocumentMetadata = {
  period: any;
  document_proof: any;
  ai_extraction: AiExtraction;
  risk_editor?: RiskEditor;
};

type AiExtraction = {
  data: GenericRecord;
  metadata: GenericRecord;
};

export type RiskEditor = {
  highest_risk_level: string;
  editor_highest_risk: string;
  risk_level_resolution: string;
  risk_level_resolution_description: string;
  editors_in_metadata: EditorInMetadata[];
};

export type EditorInMetadata = {
  vendor_name: string;
  risk_level: string;
  method_found: string;
};
